import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PieChartIcon, BarChart3 } from "lucide-react";
import { CategoryPieChart } from "../charts/CategoryPieChart";
import { PaymentBarChart } from "../charts/PaymentBarChart";
import { Expense } from "@/types/expense";
import { ScrollArea, ScrollBar } from "@/components/ui/scroll-area";
import { motion } from "framer-motion";

interface ChartTabsProps {
  expenses: Expense[];
  totalExpenses: number;
}

export const ChartTabs = ({ expenses, totalExpenses }: ChartTabsProps) => {
  return (
    <Tabs defaultValue="categories" className="space-y-4">
      <ScrollArea className="w-full">
        <TabsList className="bg-gray-100/80 backdrop-blur-sm p-1 rounded-lg inline-flex min-w-max">
          <motion.div whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.98 }}>
            <TabsTrigger value="categories" className="flex items-center gap-2 data-[state=active]:bg-white data-[state=active]:shadow-sm">
              <PieChartIcon className="h-4 w-4" />
              Categories
            </TabsTrigger>
          </motion.div>
          <motion.div whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.98 }}>
            <TabsTrigger value="payments" className="flex items-center gap-2 data-[state=active]:bg-white data-[state=active]:shadow-sm">
              <BarChart3 className="h-4 w-4" />
              Payments
            </TabsTrigger>
          </motion.div>
        </TabsList>
        <ScrollBar orientation="horizontal" />
      </ScrollArea>

      <ScrollArea className="h-[500px] w-full rounded-lg">
        <TabsContent value="categories" className="mt-0 min-h-[500px]">
          <CategoryPieChart expenses={expenses} totalExpenses={totalExpenses} />
        </TabsContent>

        <TabsContent value="payments" className="mt-0 min-h-[500px]">
          <PaymentBarChart expenses={expenses} />
        </TabsContent>
      </ScrollArea>
    </Tabs>
  );
};